import React, { useState } from 'react';
import { Button, Text, Tooltip } from '@fragments';
import { IconAlertCircle, IconCheck, IconFingerprint, IconMovie, IconPlayerPlayFilled } from '@tabler/icons-react';
import { compactCount } from '../../../../components/AccountSummary';
import { formatDuration, unavailable } from '../../format';
import './styles.scss';

// One Reel of the profile as its 9:16 cover: length and views over the picture, and under
// it the button that chooses it ("Selecionar vídeo" → "Selecionado"). Nothing on the cover
// looks like a checkbox, so an unchosen Reel never reads as chosen: it rests a step back
// (0.7) and comes forward on hover or once chosen. The cover is a pointer shortcut for the
// same toggle; the button is the control. One the backend will not analyze stays visible
// but inert, with the reason on it and the whole explanation in its tooltip. One a failed
// mapping could not use keeps its ring in the error tone and offers to remove it.
export default function ReelCard({ t, locale, video, order, full, bounds, onToggle, onRemove, style }) {
  const [broken, setBroken] = useState(false);
  const reason = video.selectable ? null : unavailable(video.unavailable_reason);
  const ReasonIcon = reason?.icon;
  const duration = formatDuration(video.duration_seconds);
  const views = video.metrics?.views;
  const cover = !broken && video.preview?.url;
  const chosen = order > 0;
  const failed = !!reason && chosen;
  const blocked = !!reason || (full && !chosen);
  const label = [video.caption || t('personalityUntitled'), duration, reason && t(reason.label, bounds)].filter(Boolean).join(' · ');
  const toggle = () => { if (!blocked) onToggle(video); };

  const action = failed
    ? <Button variant="rounded" color="error" size="small" fullWidth preventLoading startIcon={<IconAlertCircle />} onClick={() => onRemove(video.id)}>{t('personalityRemoveVideo')}</Button>
    : <Button variant="rounded" color={chosen ? 'inverse' : 'overlay'} size="small" fullWidth preventLoading disabled={blocked}
      startIcon={chosen ? <IconCheck /> : undefined} aria-pressed={reason ? undefined : chosen} onClick={toggle}>
      {t(chosen ? 'personalitySelectedVideo' : 'personalitySelectVideo')}
    </Button>;

  const card = <div role="group" aria-label={label} style={style}
    className={`studio-reel${chosen ? ' is-selected' : ''}${reason ? ' is-unavailable' : ''}${failed ? ' is-failed' : ''}${full && !chosen && !reason ? ' is-full' : ''}`}>
    <span className="studio-reel__media" aria-hidden="true" onClick={toggle}>
      {cover ? <img src={cover} alt="" loading="lazy" draggable={false} onError={() => setBroken(true)} /> : <span className="studio-reel__fallback"><IconMovie /></span>}
      <span className="studio-reel__shade" />
      <span className="studio-reel__pills">
        {duration && <span className="studio-reel__pill"><Text.caption>{duration}</Text.caption></span>}
        {video.in_personality && <span className="studio-reel__pill"><Text.caption left={<IconFingerprint />}>{t('personalityInUse')}</Text.caption></span>}
      </span>
      {views != null && <span className="studio-reel__views"><Text.caption left={<IconPlayerPlayFilled />}>{compactCount(views, locale)}</Text.caption></span>}
      {reason && <span className="studio-reel__veil"><ReasonIcon /><Text.caption weight={500} contrast={8}>{t(reason.label, bounds)}</Text.caption></span>}
    </span>
    <span className="studio-reel__action">{action}</span>
  </div>;
  return reason ? <Tooltip content={t(reason.hint, bounds)} placement="top">{card}</Tooltip> : card;
}
